import { fetchGQL } from "app/api"
import { ExportBillQuery, ExportBillQueryVariables } from "generated/graphql"
import { gql } from "graphql-tag"

const EXPORT_BILL = gql`
  query exportBill($orderID: Int!) {
    exportBill(orderID: $orderID)
  }
`

export const exportBill = async (
  orderId: number
): Promise<ExportBillQuery | undefined> => {
  const variables: ExportBillQueryVariables = {
    orderID: orderId,
  }
  const data = await fetchGQL<ExportBillQuery, ExportBillQueryVariables>(
    EXPORT_BILL,
    variables
  )
  return data
}
